<template>
  <main class="templateCenter-box" aria-label="模板中心">
    <!-- <NavBar :hasArrow="false" /> -->
    <van-tabs
      v-model="type"
      sticky
      color="#1890FF"
      title-active-color="#1890FF"
      @click.capture="changeTab"
      offset-top="0"
    >
      <van-tab
        v-for="(item, index) in tabLists"
        :key="index"
        :title="item.name"
      >
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text=""
            @load="onLoad"
          >
            <article class="box" v-for="(item, index) in lists" :key="index">
              <SeoLink class="top" :to="detailRoute(item)">
                <img :src="item.banner" class="banner" />
                <img
                  class="practice-icon"
                  :src="practice_icon"
                  v-if="item.temp == 1"
                />
                <img
                  class="practice-icon"
                  :src="award_icon"
                  v-if="item.temp == 4"
                />
                <header class="top-title">
                  <div class="title">{{ item.title }}</div>
                  <div class="num">
                    共{{ item.ques_count }}题 | {{ item.ref_count }}人已选用
                  </div>
                </header>
              </SeoLink>
            </article>
          </van-list>
          <footer v-if="lists.length">
            <Contact />
          </footer>
          <section v-else class="noData" aria-label="暂无模板数据">
            <div class="contact">
              <Contact :fixed="true" />
            </div>
            <div>暂无数据</div>
          </section>
          <ContactImg :visible="showContact" @hideVisible="handleContact()" />
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </main>
</template>

<script>
import SeoLink from "@/components/SeoLink.vue";
import questionOnly from "@/utils/questionOnly";
import Contact from "@/components/contact";
import ContactImg from "@/components/contactImg";
import NavBar from "@/components/navbar";
import { Toast } from "vant";
import { getToken, reLogin, setShareInfo, showServiceAble } from "@/utils/common";

export default {
  components: { Contact, ContactImg, NavBar, SeoLink },
  data() {
    return {
      showContact: false,
      type: 0,
      refreshing: false,
      loading: false,
      finished: true,
      pageSize: 10, //每页请求的数量
      total: 0, //总共的数据条数
      page: 1,
      lists: [],
      tabLists: [],
      cateId: "",
      practice_icon:
        "https://cdn-xcxcustom.weiyoubot.cn/20200914/ddde099549834d75a4f59e8653e8561e.png",
      award_icon:
        "https://cdn-xcxcustom.weiyoubot.cn/20210112/0c3abae86bce25f18b6ac0d5c7c36ebb.png",
      isInApp: wemeet.app.isTMWebview()
    };
  },
  created() {
    this.getTabLists();
  },
  mounted() {
    setShareInfo(false);
  },
  methods: {
    detailRoute(item) {
      let { id, template_id } = item;
      return {
        name: "normalDetail",
        query: { qid: template_id, tempId: id }
      };
    },
    async handleContact() {
      let res = await showServiceAble();
      if(res) {
        this.showContact = !this.showContact;
      }
      
    },
    onRefresh() {
      this.getList(1, this.cateId);
    },
    changeTab(e) {
      document.documentElement.scrollTop = 0;
      this.getList(1, this.tabLists[e].id);
    },
    onLoad() {
      this.getList(this.page + 1, this.cateId);
    },
    getTabLists() {
      let param = {
        access_token: getToken(),
        ...(this.isInApp ? {  source: 1 } : {})
      };
      questionOnly.get("/xcx/ques/v1/template/cate", param).then(res => {
        if (res.sta == 0) {
          this.tabLists = res.data;
          this.cateId = res.data[0].id;
          this.getList(1, res.data[0].id);
        } else if (res.sta === -500) {
          reLogin()
        } else {
          Toast(res.msg);
        }
      });
    },
    getList(page = 1, id) {
      this.page = page;
      let param = {
        access_token: getToken(),
        page,
        count: this.pageSize,
        cate: id,
        // source: 1 
        ...(this.isInApp ? { source: 1 } : {})
      };
      questionOnly.get("/xcx/ques/v1/template/list", param).then(res => {
        this.loading = false;
        this.refreshing = false;
        if (res.sta == 0) {
          if (id !== this.cateId) {
            this.lists = res.data;
            this.cateId = id;
          } else {
            this.lists = this.lists.concat(res.data);
          }

          if (!res.data.length) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else if (res.sta === -500) {
          reLogin()
        } else {
          Toast(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
main,
article,
header,
section,
footer {
  display: block;
}

.templateCenter-box {
  max-width: 500px;
  min-width: 320px;
  margin: 0 auto;
  position: relative;
  transition: none;
  padding-bottom: rem(60);
}
.box {
  background: #fff;
}
.top {
  display: flex;
  display: -webkit-flex;
  padding: rem(30) 0 rem(20) 0;
  margin: 0 rem(30);
  position: relative;
  align-items: center;
}
.banner {
  display: block;
  width: rem(140);
  height: rem(140);
  margin-right: rem(20);
  border-radius: rem(8);
  object-fit: cover;
  object-position: center;
  flex-shrink: 0;
}
.icon {
  width: rem(44);
  height: rem(44);
  margin-right: rem(10);
}
.tip {
  font-size: rem(26);
  color: #999;
  text-align: center;
  padding: rem(30) 0;
}

.top-title {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: space-between;
  height: rem(140);
  flex: 1;
}
.title {
  font-size: rem(30);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  max-width: rem(400);
}
.text-red {
  color: #ff7070 !important;
}
.num {
  color: #999;
  font-size: rem(24);
}
.total-count {
  position: relative;
  display: inline-block;
}

.practice-icon {
  position: absolute;
  right: left;
  top: rem(40);
  width: rem(103);
  height: rem(41);
}
.noData {
  text-align: center;
  padding: rem(30) 0;
}
/deep/ .van-sticky--fixed {
  width: 100%;
  max-width: 500px;
  min-width: 320px;
  left: auto;
  right: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/questionList/templateCenter.vue